import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";
import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => {
    const MOBILE_BREAKPOINT = getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE);

    return {
        iconButton: {
            padding: 0,
        },
        icon: {
            width: 26,
            height: 26,
        },
        counter: {
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(0.5, 3),
            borderRadius: "26px",
            // Unknown color in theme from Figma
            border: `1px solid #4A148C0D`,
            [MOBILE_BREAKPOINT]: {
                flexGrow: 1,
            },
        },
        counterText: {
            minWidth: 28,
        },
        counterContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: theme.spacing(1),
            width: "100%",
        },
        fixedButtonContainer: {
            height: 44,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
    };
});
